// Typelizer digest 88bd9e13d27d4c50ff309131424762ab
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** PATCH /bank_statement_uploads/:id/confirm */
  confirm: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/bank_statement_uploads/:id/confirm', params, options),
    method: 'patch',
  }),

  /** GET /bank_statement_uploads/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/bank_statement_uploads/:id', params, options),
    method: 'get',
  }),
}
